/**
 * mock模拟接口
 */
import http from '../http';
import Qs from 'qs';

// 服务管理-服务管理-服务列表 v1.3.3 废弃
// const getListOrganizations = params =>
//   http
//     .get('/sysOrganizations/listOrganizations', { params })
//     .then(res => res.data);
// 服务管理-服务管理-设置服务状态
// const setstatus = (params) => http.put('/sysOrganizations/status',Qs.stringify(params)).then(res => res.data);
const setstatus = (params) =>
  http({
    method: 'put',
    url: `/sysOrganizations/status`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-服务管理-添加服务
const postOrganizations = (params) =>
  http
    .post('/sysOrganizations/organizations', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);
// 服务管理-服务管理-服务详情
const getOrganization = (params) =>
  http.get('/sysOrganizations/organization', { params }).then((res) => res.data);
// 服务管理-服务管理-校区管理
const getOrgBranch = (params) =>
  http
    .get('/sysOrganizationBranchs/orgBranch', { params })
    .then((res) => res.data);
// 服务管理-服务管理-校区管理-添加校区
const postBranch = (params) =>
  http({
    method: 'post',
    url: `/sysOrganizationBranchs/branch`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-服务管理-校区管理-校区修改
const putSclbranch = (params) =>
  http({
    method: 'put',
    url: `/sysOrganizationBranchs/branch`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-服务管理-校区管理-校区删除
const delSclBranch = (params) =>
  http
    .delete('/sysOrganizationBranchs/branch', { params })
    .then((res) => res.data);
// 服务管理-服务管理-推荐至教育局 v1.3.3废除
// const getRecommendBureau = params =>
//   http
//     .get('/educationBureau/recommendBureau', { params })
//     .then(res => res.data);
// 服务管理-服务管理-推荐至教育局-提交 v1.3.3废弃
// const postOrgRecommends = params =>
//   http({
//     method: 'post',
//     url: `/orgEducationBureaus/orgRecommends`,
//     data: params,
//     headers: { 'Content-Type': 'application/json' }
//   }).then(res => res.data);
// 服务管理-服务管理-编辑详情
const getOrganizationUpdateDetail = (params) =>
  http
    .get('/sysOrganizations/organizationUpdateDetail', { params })
    .then((res) => res.data);
// 服务管理-服务管理-修改服务
const putOrganization = (params) =>
  http({
    method: 'put',
    url: `/sysOrganizations/organization`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 服务管理-学校管理-学校列表
const getListSchools = (params) =>
  http.get('/sysSchools/listSchools', { params }).then((res) => res.data);
// const getListSchools = params => http.get("/sysSchools/listSchools", { params }).then(res => res.data);

// 企业微信同步通讯录
const getCorpSecret = (params) =>
  http.get('/wxcorp/corpSecret', { params }).then((res) => res.data);

// 家校通讯录数据同步
const getCorpStuSecret = (params) =>
  http.get('/wxcorp/corpStuSecret', { params }).then((res) => res.data);

// 获取企业微信信息步
const getQywxSchool = (params) =>
  http.get('/sysSchools/qywx/school', { params }).then((res) => res.data);

// 服务管理-学校管理-学校列表-添加
const postSchool = (params) =>
  http({
    method: 'post',
    url: `/sysSchools/school`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 修改企业微信id
const putQywxSchool = (params) =>
  http({
    method: 'put',
    url: `/sysSchools/qywx/school`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 服务管理-学校管理-学校列表-修改
const putSysSchool = (params) =>
  http({
    method: 'put',
    url: `/sysSchools/sysSchool`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-学校管理-学校详情 (v1.3.1 接口废弃)
// const getSchoolDetail = params =>
//   http.get('/sysSchools/schoolDetail', { params }).then(res => res.data);
// 服务管理-学校管理-学校修改详情
const getSysSchool = (params) =>
  http.get('/sysSchools/sysSchool', { params }).then((res) => res.data);
// 服务管理-学校管理-学校自关联服务分页列表 v1.3.3废弃
// const getAssociatedOrg = params =>
//   http.get('/sysSchools/associatedOrg', { params }).then(res => res.data);
// 服务管理-学校管理-学校已关联服务 v1.3.3 废弃
// const getSchoolAssociatedOrg = params =>
//   http
//     .get('/sysSchools/school/associatedOrg', { params })
//     .then(res => res.data);
// 服务管理-学校管理-学校关联服务提交
const postSchoolAssociatedOrg = (params) =>
  http({
    method: 'post',
    url: `/sysSchools/school/associatedOrg`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-学校管理-学校详情-提交
const putSchoolStatu = (params) =>
  http({
    method: 'put',
    url: `/sysSchools/schoolStatu`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-学校管理-删除
const delSchool = (params) =>
  http.delete('/sysSchools/school', { params }).then((res) => res.data);
// 服务管理-学校管理-学校添加/修改-隶属教育局
const getEduBureauData = (params) =>
  http.get('/educationBureau/eduBureau', { params }).then((res) => res.data);

// 服务管理-教育局管理-教育局列表
const getListBureau = (params) =>
  http.get('/educationBureau/listBureau', { params }).then((res) => res.data);
// 服务管理-教育局管理-添加教育局
const postEducationBureau = (params) =>
  http({
    method: 'post',
    url: `/educationBureau/educationBureau`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-教育局管理-修改教育局
const putEducationBureau = (params) =>
  http({
    method: 'put',
    url: `/educationBureau/educationBureau`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-教育局管理-教育局列表-删除
const delEducationBureau = (params) =>
  http
    .delete('/educationBureau/educationBureau', { params })
    .then((res) => res.data);
// 服务管理-教育局管理-教育局详情-提交
const putEducationBureauStatu = (params) =>
  http({
    method: 'put',
    url: `/educationBureau/educationBureau/statu`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 服务管理-教育局管理-教育局详情-服务列表
const geteduOrg = (params) =>
  http.get('/orgEducationBureaus/edu/org', { params }).then((res) => res.data);

// // 系统设置-运营管理列表 v1.3.1废弃
// const getOperatorList = params =>
//   http.get('/sysOperators/operatorList', { params }).then(res => res.data);
// 系统设置-运营管理列表-删除
const delOperator = (params) =>
  http.delete('/sysOperators/operator', { params }).then((res) => res.data);
// 系统设置-运营管理列表-修改密码
const putOperatorpwd = (params) =>
  http({
    method: 'put',
    url: `/sysOperators/operator/pwd`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 系统设置-运营管理列表-运营用户修改（无密码）
const putOperatorNo = (params) =>
  http({
    method: 'put',
    url: `/sysOperators/operator`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 系统设置-运营管理列表-运营用户添加
const postOperator = (params) =>
  http({
    method: 'post',
    url: `/sysOperators/operator`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 运营设置-课程分类设置
const getCourseTypeList = (params) =>
  http.get('/courseType/courseTypeList', { params }).then((res) => res.data);
// 运营设置-课程分类设置-添加课程
const postCourseType = (params) =>
  http({
    method: 'post',
    url: `/courseType/courseType`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 运营设置-课程分类设置-删除
const delCourseType = (params) =>
  http.delete('/courseType', { params }).then((res) => res.data);
// 运营设置-课程分类设置-编辑
const putCourseType = (params) =>
  http({
    method: 'put',
    url: `/courseType`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 运营用户详情-管理员
const getSysOperators = (params) =>
  http.get('/sysOperators', { params }).then((res) => res.data);
// 运营用户详情-管理员修改
const putoperator = (params) =>
  http({
    method: 'put',
    url: `/sysOperators/org/operator`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 删除服务
const delSysOrganizations = (params) =>
  http
    .delete(
      '/sysOrganizations',
      { params },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);
// 获取未合作服务
const getNewListOrganizations = (params) =>
  http
    .get('/sysOrganizations/new/listOrganizations', { params })
    .then((res) => res.data);

// 获取未合作服务
const getListMerchants = (params) =>
  http
    .get('/sysOrganizations/listMerchants', { params })
    .then((res) => res.data);

// 添加机构V3

const addOrgV3 = (params) =>
  http
    .post('/sysOrganizations/organizationsV3', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 修改机构v3
const editOrggV3 = (params) =>
  http
    .post('/sysOrganizations/organizationUpdateV3', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 获取机构商户信息 v1.3.3废除
// const getOrgMerchantInfo = params =>
//   http
//     .get('/sysOrganizations/organizationMerchantInfo', { params })
//     .then(res => res.data);
// 轮播图管理-平台列表
const getSysBanner = (params) =>
  http.get('/sysBanner/list', { params }).then((res) => res.data);

// 轮播图管理-学校列表
const getSchoolBanner = (params) =>
  http.get('/sysBanner/listOrgSch', { params }).then((res) => res.data);

// 轮播图管理-删除轮播图
const getDeteleBanner = (params) =>
  http.post('/sysBanner/delete', Qs.stringify(params)).then((res) => res.data);

// 轮播图管理-新增轮播图
const getAddBanner = (params) =>
  http({
    method: 'post',
    url: `/sysBanner/banner`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 轮播图管理-修改轮播图
const getUpdateBanner = (params) =>
  http({
    method: 'post',
    url: `/sysBanner/updateBanner`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 平台端 - 数据概览
const getPlatBasicData = (params) =>
  http.get('/stat/plat/basicData', { params }).then((res) => res.data);

// 平台端 - 营收统计
const getPlatRevenueData = (params) =>
  http.get('/stat/plat/revenueData', { params }).then((res) => res.data);

// 平台端 - 今日数据
const getPlatDayData = (params) =>
  http.get('/stat/plat/day', { params }).then((res) => res.data);

// 平台端 - 托管概览
const getPlatTuoguanData = (params) =>
  http.get('/stat/plat/tuoguan', { params }).then((res) => res.data);

// 平台端 - 课程概览
const getPlatCourseTypeData = (params) =>
  http.get('/stat/plat/courseType', { params }).then((res) => res.data);

// 平台端 - 查询教育局列表 v1.3.1
const getEduListNew = (params) =>
  http.get('/educationBureau/listBureauNew', { params }).then((res) => res.data);

// 平台端 - 查询教育局详情 v1.3.1
const getEduDetailsNew = (params) =>
  http
    .get('/educationBureau/educationBureauNew', { params })
    .then((res) => res.data);

// 平台端 - 教育局服务统计 v1.3.1
const geteduOrgNew = (params) =>
  http.get('/educationBureau/getRelOrg', { params }).then((res) => res.data);

// 平台端 - 获取学校列表 v1.3.1
const getListSchoolsNew = (params) =>
  http.get('/sysSchools/listSchoolsNew', { params }).then((res) => res.data);
// 平台端 - 获取学校列表 v1.3.1  根据行政编码查
const getListSchoolsNewByOfficeAreaCode = (params) =>
  http
    .get('/theUserIdentity/dataSearch/searchSchool', { params })
    .then((res) => res.data);

// 机构端 - 获取学校列表 v1.3.1
const getListSchoolsNewAdmin = (params) =>
  http
    .get('/theUserIdentity/courseClass/getRelSchool', { params })
    .then((res) => res.data);

// 平台端 - 获取学校详情 v1.3.1
const getSchoolDetailsNew = (params) =>
  http.get('/sysSchools/getSchoolDetailNew', { params }).then((res) => res.data);

// 平台端 - 获取学校已关联机构 v1.3.1
const getSchoolAssociatedOrgNew = (params) =>
  http
    .get('/sysSchools/school/associatedOrgNew', { params })
    .then((res) => res.data);

// 平台端 - 查询服务管理（运营端） v1.3.1
const getOrgListNew = (params) =>
  http
    .get('/sysOrganizations/listOrganizationsNew', { params })
    .then((res) => res.data);

// 平台端 - 服务管理（未合作）（运营端） v1.3.1
const getOrgListNewNoCoo = (params) =>
  http
    .get('/sysOrganizations/new/listOrganizationsNew', { params })
    .then((res) => res.data);

// 平台端 - 服务详情 v1.3.1
const getOrgDetailsNew = (params) =>
  http
    .get('/sysOrganizations/organizationNew', { params })
    .then((res) => res.data);

// 平台端 - 服务详情 教育局统计 v1.3.1
const getOrgEdusNew = (params) =>
  http.get('/sysOrganizations/getRelBureau', { params }).then((res) => res.data);

// 平台端 - 服务详情 学校统计 v1.3.1
const getOrgSchoolsNew = (params) =>
  http.get('/sysOrganizations/getRelSchool', { params }).then((res) => res.data);

// 平台端 - 服务详情 商户信息 v1.3.1
const getOrgMerchantInfoNew = (params) =>
  http
    .get('/sysOrganizations/organizationMerchantInfoNew', { params })
    .then((res) => res.data);

// 平台端 - 修改服务名称 v1.3.1
const updateOrgName = (params) =>
  http({
    method: 'post',
    url: `/sysOrganizations/updateOrgName`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 平台端 - 查询可推荐的教育局列表 v1.3.1
const getRecommendEdus = (params) =>
  http
    .get('/educationBureau/recommendBureauNew', { params })
    .then((res) => res.data);

// 查询学校可关联的机构列表 v1.3.3
const getAssociatedOrgNew = (params) =>
  http.get('/sysSchools/associatedOrgNew', { params }).then((res) => res.data);

// 服务管理-服务管理-推荐至教育局-提交  v1.3.3
const postOrgRecommendsNew = (params) =>
  http({
    method: 'post',
    url: `/orgEducationBureaus/orgRecommendsNew`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 教育局解除机构合作 v1.3.3
const disassociateOrgAndEduNew = (params) =>
  http({
    method: 'put',
    url: `/orgEducationBureaus/edu/org/new`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);

// 学校解除机构关联 v1.3.3
const putRemoveOrgBySchoolNew = (params) =>
  http
    .put('/sysSchools/school/removeOrgNew', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

// 系统设置-运营管理列表 v1.3.1
const getOperatorListNew = (params) =>
  http.get('/sysOperators/operatorListNew', { params }).then((res) => res.data);

// 运营端 单位管理-学校分页 v2.1.18
const getSysSchoolsApi = (params) =>
  http
    .get('/theUserIdentity/sysSchools/schoolPage', { params })
    .then((res) => res.data);

// 单位管理-家长端小程序码
const getParentsSmallProgramCodeApi = (params) =>
  http
    .get('/theUserIdentity/sysSchools/parentsSmallProgramCode', { params })
    .then((res) => res.data);

// 平台端 - 平台管理 平台列表
const getAdminOrgPage = (params) =>
  http.get('/admin/common/adminOrgPage', { params }).then((res) => res.data);
// 查询平台印章
const getSignetForOperation = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/getSignet', { params })
    .then((res) => res.data);
// 编辑平台印章
const saveOrUpdateSignetForOperation = (params) =>
  http({
    method: 'post',
    url: `/theUserIdentity/sysStaticDatas/saveOrUpdateSignet`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 删除平台印章
const deleteOrUpdateSignetForOperation = (params) =>
  http
    .get(`/theUserIdentity/sysStaticDatas/deleteSignet`, { params })
    .then((res) => res.data);

// 查询平台logo
const getSignetForOperationLogo = (params) =>
  http.get('/admin/sysStaticDatas/getLogo', { params }).then((res) => res.data);
// 编辑平台logo
const saveOrUpdateSignetForOperationLogo = (params) =>
  http({
    method: 'post',
    url: `/admin/sysStaticDatas/saveOrUpdateLogo`,
    data: params,
    headers: { 'Content-Type': 'application/json' }
  }).then((res) => res.data);
// 删除平台印章
const deleteOrUpdateSignetForOperationLogo = (params) =>
  http
    .get(`/theUserIdentity/sysStaticDatas/deleteLogo`, { params })
    .then((res) => res.data);

export default {
  // getListOrganizations,// v1.3.3废弃
  setstatus,
  postOrganizations,
  getOrganization,
  getListSchools,
  getListBureau,
  getOrgBranch,
  postBranch,
  putSclbranch,
  delSclBranch,
  // getRecommendBureau,
  // postOrgRecommends,
  getOrganizationUpdateDetail,
  putOrganization,
  delEducationBureau,
  postEducationBureau,
  putEducationBureau,
  postSchool,
  // getSchoolDetail,
  getSysSchool,
  // getAssociatedOrg,
  // getSchoolAssociatedOrg,
  postSchoolAssociatedOrg,
  // getOperatorList,
  delOperator,
  getSysOperators,
  putoperator,
  putOperatorpwd,
  putOperatorNo,
  postOperator,
  putSchoolStatu,
  delSchool,
  putEducationBureauStatu,
  geteduOrg,
  getCourseTypeList,
  postCourseType,
  delCourseType,
  putCourseType,
  getEduBureauData,
  putSysSchool,
  delSysOrganizations,
  getNewListOrganizations,
  putQywxSchool,
  getCorpSecret,
  getCorpStuSecret,
  getQywxSchool,
  getListMerchants,
  addOrgV3,
  editOrggV3,
  // getOrgMerchantInfo,
  getSysBanner,
  getSchoolBanner,
  getDeteleBanner,
  getAddBanner,
  getUpdateBanner,
  getPlatBasicData,
  getPlatRevenueData,
  getPlatDayData,
  getPlatTuoguanData,
  getPlatCourseTypeData,
  getEduListNew,
  getEduDetailsNew,
  geteduOrgNew,
  getListSchoolsNew,
  getListSchoolsNewAdmin,
  getListSchoolsNewByOfficeAreaCode,
  getSchoolDetailsNew,
  getSchoolAssociatedOrgNew,
  getOrgListNew,
  getOrgListNewNoCoo,
  getOrgDetailsNew,
  getOrgEdusNew,
  getOrgSchoolsNew,
  getOrgMerchantInfoNew,
  updateOrgName,
  getRecommendEdus,
  getAssociatedOrgNew,
  postOrgRecommendsNew,
  disassociateOrgAndEduNew,
  putRemoveOrgBySchoolNew,
  getOperatorListNew,
  getSysSchoolsApi,
  getParentsSmallProgramCodeApi,
  getAdminOrgPage,
  getSignetForOperation,
  saveOrUpdateSignetForOperation,
  deleteOrUpdateSignetForOperation,
  getSignetForOperationLogo,
  saveOrUpdateSignetForOperationLogo,
  deleteOrUpdateSignetForOperationLogo
};
